import { LOYALTY_ACCOUNT } from "app/shared/services/services-model.type";
import {
  SET_LOYALTY_STORE,
  SET_LOYALTY_RESET,
  FETCH_LOYALTY_ACCOUNT_REQUEST,
  FETCH_LOYALTY_ACCOUNT_SUCCESS,
  FETCH_LOYALTY_ACCOUNT_FAILURE,
  FETCH_LINK_WEBVIEW_LOYALTY_REQUEST,
  FETCH_LINK_WEBVIEW_LOYALTY_SUCCESS,
  FETCH_LINK_WEBVIEW_LOYALTY_FAILURE,
} from "./actions.type";
import {
  SetLoyaltyStore,
  SetLoyaltyReset,
  FetchLoyaltyAccountRequest,
  FetchLoyaltyAccountSuccess,
  FetchLoyaltyAccountFailure,
  LoyaltyState,
  FetchLoyaltyLinkWebviewRequest,
  FetchLoyaltyLinkWebviewSuccess,
  FetchLoyaltyLinkWebviewFailure,
} from "./types";

export const setLoyaltyStore = (payload: LoyaltyState): SetLoyaltyStore => ({
  type: SET_LOYALTY_STORE,
  payload,
});

export const setLoyaltyReset = (): SetLoyaltyReset => ({
  type: SET_LOYALTY_RESET,
});

export const fetchLoyaltyAccountRequest = (): FetchLoyaltyAccountRequest => ({
  type: FETCH_LOYALTY_ACCOUNT_REQUEST,
});

export const fetchLoyaltyAccountSuccess = (payload?: LOYALTY_ACCOUNT): FetchLoyaltyAccountSuccess => ({
  type: FETCH_LOYALTY_ACCOUNT_SUCCESS,
  payload,
});

export const fetchLoyaltyAccountFailure = (payload?: string): FetchLoyaltyAccountFailure => ({
  type: FETCH_LOYALTY_ACCOUNT_FAILURE,
  payload,
});

export const fetchLoyaltyLinkWebviewRequest = (): FetchLoyaltyLinkWebviewRequest => ({
  type: FETCH_LINK_WEBVIEW_LOYALTY_REQUEST,
});

export const fetchLoyaltyLinkWebviewSuccess = (payload?: string): FetchLoyaltyLinkWebviewSuccess => ({
  type: FETCH_LINK_WEBVIEW_LOYALTY_SUCCESS,
  payload,
});

export const fetchLoyaltyLinkWebviewFailure = (payload?: string): FetchLoyaltyLinkWebviewFailure => ({
  type: FETCH_LINK_WEBVIEW_LOYALTY_FAILURE,
  payload,
});
